import { render } from "./Login.vue?vue&type=template&id=2229c850&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./Login.vue?vue&type=style&index=0&id=2229c850&lang=css"
import "./Login.vue?vue&type=style&index=1&id=2229c850&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2229c850"]])

export default __exports__